export const dashHome = {
  index: {
    boxes: {
      reservas: "Reservas",
      checkins: "Check-ins",
      ocupacion: "Ocupación",
      facturacion: "Facturación",
      ingresosTotal: "Total de ingresos",
      saldos: "Saldos pendientes",
      solicitudes: "Solicitudes IA",
      facturas: "Facturas pendientes",
      acciones: "Acciones pendientes",
      salen: "Salen hoy",
      llegadas: "Próximas llegadas",
      ingresosDesglose: "Desglose de ingresos",
    },
    editToolbar: {
      done: "Listo",
      addBox: "Añadir caja",
      reset: "Restablecer",
      hint: "Arrastra para mover · tira de la esquina para redimensionar",
      allBoxesVisible: "Todas las cajas están visibles.",
      removeTitle: "Quitar",
      showOnboarding: "Mostrar el aviso de configuración",
    },
  },
  arrivals: {
    viewAll: "Ver todas las llegadas",
  },
  todayLeaving: {
    title: "Huéspedes que salen hoy",
    subtitle: "Check-outs programado para la fecha de hoy.",
    empty: "No hay huéspedes con salida hoy.",
    loading: "Cargando salidas de hoy…",
    balance: "Saldo",
    balanceDueTitle: "Saldo pendiente: {amount} {currency}",
    paid: "Pagado",
    paidTitle: "Reserva pagada",
    viewAll: "Ver todas las salidas",
  },
  mobileNotice: {
    sheetAriaLabel: "Descarga la app de WACheckin",
    closeAriaLabel: "Cerrar",
    title: "Saca todo el partido a WACheckin",
    desc: "El panel está pensado para <b>escritorio</b>. Desde el móvil tienes un resumen; para gestionar <b>todas las funciones</b> con comodidad, ábrelo en tu ordenador o descarga nuestra <b>app</b>.",
    appStorePrefix: "Descárgalo en el",
    googlePlayPrefix: "Disponible en",
    continueOnMobile: "Seguir viendo en el móvil",
  },
};
